import React from 'react';
import { Link } from 'react-router-dom';

function GuideAccountCTA({ title = 'Ready to start your summer college research?' }) {
  return (
    <section className="timeline-page__account-cta" aria-label="Create an account">
      <span className="timeline-page__action-kicker">Free MVP account</span>
      <h2>{title}</h2>
      <p>
        Build your first dashboard to compare colleges, save notes, and keep your research organized
        before senior year gets busy.
      </p>
      <div className="timeline-page__action-row">
        <Link to="/signup" className="timeline-page__internal-link">Create Account</Link>
        <Link to="/support" className="timeline-page__internal-link timeline-page__internal-link--secondary">Read Support</Link>
      </div>
    </section>
  );
}

export default GuideAccountCTA;
